<script lang="ts">
  import "../app.postcss";
  import { afterNavigate } from "$app/navigation";
  import { browser } from "$app/environment";
  import { page } from "$app/stores";
  import { onMount } from "svelte";
  import AuthRedirectNotice from "$lib/components/AuthRedirectNotice.svelte";
  import PrivacyConsentBanner from "../components/PrivacyConsentBanner.svelte";
  import PrivacyPreferencesDialog from "../components/PrivacyPreferencesDialog.svelte";
  import { initAnalyticsIfAllowed, trackPageView } from "$lib/analytics";
  import { isEmbedPath } from "$lib/embed/embed-route";
  import { initializePrivacyConsent, OPEN_PRIVACY_PREFERENCES_EVENT } from "$lib/privacy-consent";

  let privacyPreferencesOpen = false;

  // The embeddable widget renders inside partner websites: no consent banner
  // and no page views there (see $lib/embed/embed-route).
  $: embedded = isEmbedPath($page.url.pathname);

  const sendPageView = () => {
    if (!browser || isEmbedPath(window.location.pathname)) {
      return;
    }
    initAnalyticsIfAllowed();
    trackPageView();
  };

  const markE2eReady = () => {
    if (browser) {
      document.documentElement.dataset.e2eReady = "true";
    }
  };

  let afterNavigateInitialized = false;

  if (browser) {
    afterNavigate(() => {
      markE2eReady();
      if (!afterNavigateInitialized) {
        afterNavigateInitialized = true;
        return;
      }
      sendPageView();
    });
  }

  onMount(() => {
    if (!browser) {
      return;
    }

    initializePrivacyConsent();
    markE2eReady();

    sendPageView();

    const openPrivacyPreferences = () => (privacyPreferencesOpen = true);
    window.addEventListener(OPEN_PRIVACY_PREFERENCES_EVENT, openPrivacyPreferences);
    return () => window.removeEventListener(OPEN_PRIVACY_PREFERENCES_EVENT, openPrivacyPreferences);
  });
</script>

<svelte:head>
  <title>Green Skills Coach from GetZero - Discover your green career pathway!</title>
</svelte:head>

<AuthRedirectNotice />
<slot />
{#if !embedded}
  {#if !privacyPreferencesOpen}
    <PrivacyConsentBanner on:manage={() => (privacyPreferencesOpen = true)} />
  {/if}
  <PrivacyPreferencesDialog open={privacyPreferencesOpen} onClose={() => (privacyPreferencesOpen = false)} />
{/if}
